import { render, h } from 'preact';
import App from './app';

const init = () => {
  const urlObject = new URL(document.location.href);
  const searchParams = urlObject.searchParams;

  const items = {};
  items.country = drupalSettings?.coit?.domain === 'coit_us' ? 'US' : 'CA';

  const advance = searchParams.get('advance') !== '1';
    // Only use these if the
  items.franchise = advance ? null : (drupalSettings?.coit?.franchise ?? null);
  items.postal_code = advance ? null : (drupalSettings?.coit?.postal_code ?? null);

  items.extra_info = advance ? {} : (drupalSettings?.coit?.extra_info ?? {});
  const appElement = document.getElementById('app');

  if (appElement) {
    // Remove the placeholder spinner before mounting.
    appElement.innerHTML = '';
    render(<App {...items}/>, appElement);
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
